import { CopyPasteFilesService } from '~/ng-services/attachments/copy-paste-files.service';

angular
    .module('tradersyard')
    .factory('postFormFactory', [
        'graph-storage-factory',
        '$flex',
        function ($storage, $flex) {
            var container = {};

            var template = {
                id: 0,
                title: '',
                content: '',
                privacy: 'public',
                groups: [],
                photos: [],
                videos: [],
                documents: [],
                links: [],
                new: {
                    photos: [],
                    videos: [],
                    documents: [],
                    links: [],
                },
                trash: {
                    photos: [],
                    videos: [],
                    documents: [],
                    links: [],
                },
                progress: {
                    photos: [],
                    videos: [],
                    documents: [],
                    links: [],
                },
                processing: 0,
            };

            if ($flex.data.node) {
                if ($flex.data.node.ban_public_posting) {
                    template.privacy = 'protected';
                }
            }

            return {
                template: function (data, id) {
                    container[id] = angular.copy(angular.isObject(data) ? data : {});

                    container[id] = angular.extend(angular.copy(template), container[id]);

                    return container[id];
                },
            };
        },
    ])
    .directive('postForm', [
        '$parse',
        'postFormFactory',
        'graph-post-factory',
        '$flex',
        '$flex.array',
        '$timeout',
        '$rootScope',
        '$socket',
        'CopyPasteFilesService',
        function ($parse, $factory, $client, $flex, $array, $timeout, $root, $socket, copyPasteFiles) {
            return {
                scope: true,
                priority: -5,
                link: function ($scope, $element, $attr) {
                    $scope.ui = {
                        privacy: false,
                        group: false,
                    };

                    $scope.shareFlag = false;

                    $scope.privacy = ['public', 'protected', 'private'];

                    $scope.entry = $parse($attr.entry)($scope);

                    $scope.client = $client.entry($parse($attr.entry)($scope), $parse($attr.entryId)($scope));

                    var Listener = {
                        data: [],
                        concat: function (listeners) {
                            Listener.data = Listener.data.concat(listeners);
                        },
                        push: function (listener) {
                            Listener.data.push(listener);
                        },
                        clear: function () {
                            Listener.data.forEach(function (listener) {
                                listener();
                            });
                        },
                    };

                    $scope.banPublicPosting = false;

                    if ($flex.data.node) {
                        angular.extend($scope.banPublicPosting, $flex.data.node.ban_public_posting || false);
                    }

                    var build = function () {
                        $scope.formPost = $factory.template(
                            $parse($attr.postData)($scope),
                            $parse($attr.postId)($scope)
                        );

                        if ($scope.formPost.id !== 0) {
                            var groups = [];

                            for (var i = 0; i < $scope.formPost.groups.length; ++i) {
                                groups.push($scope.formPost.groups[i].id);
                            }

                            $root.$broadcast('post-form-select', $scope.formPost.id, groups);
                        }

                        $scope.$on('post-form-update', function (e, id, groups) {
                            if ($scope.formPost.id !== id) return;

                            $scope.formPost.groups = groups;
                        });
                    };

                    $timeout(function () {
                        if ($scope.mode === undefined || $scope.mode === 'edit') {
                            build();
                        } else {
                            var watch = $scope.$watch('mode', function (nval, oval) {
                                if (nval !== oval) {
                                    if (nval === 'edit') {
                                        build();
                                        watch();
                                    }
                                }
                            });
                        }
                    });

                    $scope.attach = {
                        photo: function (id) {
                            $scope.attach.trigger(id, 'photo');
                        },
                        video: function (id) {
                            $scope.attach.trigger(id, 'video');
                        },
                        document: function (id) {
                            $scope.attach.trigger(id, 'document');
                        },
                        trigger: function (id, type) {
                            document.getElementById(id + '-' + type + '-input').click();
                        },
                    };

                    $scope.input = {
                        photo: {},
                        video: {},
                        document: {},
                    };

                    var createlock = 0;
                    var uploadLock = 0;

                    var requestQueueLock = false;
                    $scope.requestQueueLock = false;

                    /**
                     * Can attach any file types. Works with files that you can get from clipboard or drag-n-drop events.
                     * @param {File[]} files
                     */
                    function attachAnyFiles(files) {
                        files.forEach((file) => {
                            switch (true) {
                                case file.type.startsWith('image/'):
                                    copyPasteFiles.toLegacyFile(file).then((legacyFile) => {
                                        $scope.input.photo = legacyFile;
                                        $scope.fn.attach.photos();
                                    });
                                    break;

                                case file.type.startsWith('video/'):
                                    copyPasteFiles.toLegacyFile(file).then((legacyFile) => {
                                        $scope.input.video = legacyFile;
                                        $scope.fn.attach.videos();
                                    });
                                    break;
                                default:
                                    copyPasteFiles.toLegacyFile(file).then((legacyFile) => {
                                        $scope.input.document = legacyFile;
                                        $scope.fn.attach.documents();
                                    });
                                    break;
                            }
                        });
                    }

                    /**
                     * Fired when drag-n-drop is detected.
                     * @param files
                     */
                    $scope.onPostInputAreaDrop = (files) => {
                        attachAnyFiles(files);
                    };

                    /**
                     * Fired when paste event is detected. Works with files and links.
                     * @param $event
                     */
                    $scope.attachAnything = function ($event) {
                        const files = copyPasteFiles.filesFromAngularEvent($event);

                        if (!files.length) {
                            $scope.fn.attach.links($event);
                            return;
                        }

                        // prevent pasting file path to input box
                        $event.preventDefault();

                        attachAnyFiles(files);
                    };

                    $scope.fn = {
                        isEmpty: function () {
                            var items = 0;
                            angular.forEach(['photos', 'videos', 'documents', 'links'], function (space) {
                                items += $scope.formPost[space].length;
                            });

                            return items <= 0 && $scope.formPost.content.trim().length === 0;
                        },
                        submit: function (node) {
                            if (!$scope.requestQueueLock) {
                                $scope.requestQueueLock = true;

                                var data = angular.copy(node);

                                angular.forEach(['photos', 'videos', 'documents', 'links', 'groups'], function (space) {
                                    data[space] = $scope.fn.query(data, space);
                                });

                                if ($scope.formPost.processing <= 0) {
                                    if (parseInt(node.id) === 0) {
                                        $scope.client
                                            .create(data, { params: { share: $scope.shareFlag } })
                                            .then(function (response) {
                                                createlock = 0;

                                                if (response.data.state === 0) {
                                                    var posts = $parse($attr.pool)($scope);

                                                    if (
                                                        posts
                                                            .map(function (item) {
                                                                return Number(item.id);
                                                            })
                                                            .indexOf(Number(response.data.data.id)) === -1
                                                    ) {
                                                        posts.unshift(angular.copy(response.data.data));
                                                        $socket.emit('join:post', [response.data.data.id]);
                                                    }

                                                    $scope.formPost = $factory.template(undefined, 0);

                                                    $scope.ui.privacy = false;
                                                    $scope.ui.group = false;

                                                    $scope.client.publishToFacebook(response.data.data.id, data, {
                                                        params: { share: $scope.shareFlag },
                                                    });

                                                    if ($attr.finish) {
                                                        var phase = $scope.$parent.$$phase;
                                                        if (phase == '$apply' || phase == '$digest')
                                                            $scope.$parent.$eval($attr.finish);
                                                        else $scope.$parent.$apply($attr.finish);
                                                    }
                                                }

                                                $scope.requestQueueLock = false;
                                            })
                                            .catch(() => {
                                                $scope.requestQueueLock = false;
                                            });
                                    } else {
                                        if ($scope.fn.isEmpty()) {
                                            $root.$broadcast('graph-modal-show', {
                                                title: 'Warning',
                                                content:
                                                    'Please enter post content or post will be removed. Do you really want to remove post?',
                                                type: 'prompt',
                                                scope: 'post',
                                                buttons: [
                                                    {
                                                        name: 'confirm',
                                                        text: 'Yes',
                                                    },
                                                    {
                                                        name: 'discard',
                                                        text: 'No',
                                                    },
                                                ],
                                            });

                                            Listener.concat([
                                                $root.$on('modal:event:close', function (e) {
                                                    createlock = 0;
                                                    $scope.requestQueueLock = false;
                                                    Listener.clear();
                                                    return;
                                                }),
                                                $root.$on('modal:post:button', function (e, button) {
                                                    createlock = 0;
                                                    $scope.requestQueueLock = false;
                                                    Listener.clear();

                                                    switch (button.name) {
                                                        case 'confirm':
                                                            $root.$broadcast('post:delete', $scope.formPost);
                                                            break;
                                                        case 'discard':
                                                            break;
                                                    }
                                                }),
                                            ]);
                                        } else {
                                            for (var type in $scope.formPost.trash) {
                                                var trash = $scope.formPost.trash[type];

                                                for (var i = 0; i < trash.length; i++) {
                                                    var item = trash[i];

                                                    $scope.client[type]($scope.formPost.id).delete(item.id);
                                                    $scope.formPost.trash[type].splice(i, 1);
                                                }
                                            }

                                            $scope.client.update(node.id, data).then(function (response) {
                                                createlock = 0;
                                                $scope.requestQueueLock = false;

                                                if (response.data.state === 0) {
                                                    angular.forEach($parse($attr.pool)($scope), function (iterator) {
                                                        if (iterator.id === node.id)
                                                            angular.extend(iterator, response.data.data);
                                                    });

                                                    $scope.formPost = $factory.template(node, node.id);

                                                    $scope.ui.privacy = false;
                                                    $scope.ui.group = false;

                                                    if ($attr.after) {
                                                        var phase = $scope.$parent.$$phase;
                                                        if (phase == '$apply' || phase == '$digest')
                                                            $scope.$parent.$eval($attr.after);
                                                        else $scope.$parent.$apply($attr.after);
                                                    }
                                                } else {
                                                    $root.$broadcast('graph-modal-show', {
                                                        title: 'Error',
                                                        content:
                                                            response.data.data.content || 'Please enter post content.',
                                                    });
                                                }
                                            });
                                        }
                                    }
                                }
                            }

                            if (createlock === 1) {
                                return;
                            }

                            createlock = 1;
                        },
                        error: function (error) {
                            $root.$broadcast('graph-modal-show', {
                                title: 'Error',
                                content: error,
                            });
                        },
                        attach: {
                            photos: function () {
                                if ($scope.input.photo) {
                                    $scope.formPost.processing++;
                                    var photo = $scope.input.photo;
                                    $scope.formPost.progress.photos.push({
                                        name: photo.name,
                                    });
                                    $scope.client
                                        .storage($scope.formPost.id)
                                        .upload(
                                            {
                                                name: $scope.input.photo.name,
                                                photo: $scope.input.photo.base,
                                            },
                                            'photos'
                                        )
                                        .then(function (response) {
                                            $scope.formPost.progress.photos = $array.$splice(
                                                $scope.formPost.progress.photos,
                                                { name: photo.name },
                                                'name'
                                            );
                                            if (response.data.state === 0) {
                                                var $photo = response.data.data;

                                                if (!$array.$has($scope.formPost.photos, $photo, 'id')) {
                                                    $scope.formPost.new.photos.push($photo);
                                                    $scope.formPost.photos.push($photo);
                                                } else {
                                                    $root.$broadcast('graph-modal-show', {
                                                        title: 'Warning',
                                                        content: 'Adding a photo that is already attached',
                                                    });
                                                }
                                            } else {
                                                $root.$broadcast('graph-modal-show', {
                                                    title: 'Error',
                                                    content:
                                                        response.data.data.photo ||
                                                        'The file is too large or the format is incorrect.',
                                                });
                                            }
                                            $scope.formPost.processing--;
                                        });
                                }
                            },
                            videos: function () {
                                if ($scope.input.video) {
                                    $scope.formPost.processing++;

                                    var fd = new FormData();
                                    fd.append('video', $scope.input.video.file);
                                    fd.append('name', $scope.input.video.name);

                                    var video = $scope.input.video;
                                    $scope.formPost.progress.videos.push({
                                        name: video.name,
                                    });

                                    // rewrite

                                    $scope.client
                                        .storage($scope.formPost.id)
                                        .upload(fd, 'videos')
                                        .then(function (response) {
                                            $scope.formPost.progress.videos = $array.$splice(
                                                $scope.formPost.progress.videos,
                                                { name: video.name },
                                                'name'
                                            );
                                            if (response.data.state === 0) {
                                                var $video = response.data.data;

                                                if (!$array.$has($scope.formPost.videos, $video, 'id')) {
                                                    $scope.formPost.new.videos.push($video);
                                                    $scope.formPost.videos.push($video);
                                                } else {
                                                    $root.$broadcast('graph-modal-show', {
                                                        title: 'Warning',
                                                        content: 'Adding a video that is already attached',
                                                    });
                                                }
                                            } else {
                                                $root.$broadcast('graph-modal-show', {
                                                    title: 'Error',
                                                    content:
                                                        response.data.data.video ||
                                                        'The file is too large or the format is incorrect.',
                                                });
                                            }
                                            $scope.formPost.processing--;
                                        });
                                }
                            },
                            documents: function () {
                                if ($scope.input.document) {
                                    $scope.formPost.processing++;

                                    var fd = new FormData();
                                    fd.append('document', $scope.input.document.file);
                                    fd.append('name', $scope.input.document.name);

                                    var document = $scope.input.document;
                                    $scope.formPost.progress.documents.push({
                                        name: document.name,
                                    });
                                    $scope.client
                                        .storage($scope.formPost.id)
                                        .upload(fd, 'documents')
                                        .then(function (response) {
                                            $scope.formPost.progress.documents = $array.$splice(
                                                $scope.formPost.progress.documents,
                                                { name: document.name },
                                                'name'
                                            );
                                            if (response.data.state === 0) {
                                                var $document = response.data.data;

                                                if (!$array.$has($scope.formPost.documents, $document, 'id')) {
                                                    $scope.formPost.new.documents.push($document);
                                                    $scope.formPost.documents.push($document);
                                                } else {
                                                    $root.$broadcast('graph-modal-show', {
                                                        title: 'Warning',
                                                        content: 'Adding a document that is already attached',
                                                    });
                                                }
                                            } else {
                                                $root.$broadcast('graph-modal-show', {
                                                    title: 'Error',
                                                    content:
                                                        response.data.data.document ||
                                                        'The file is too large or the format is incorrect.',
                                                });
                                            }
                                            $scope.formPost.processing--;
                                        });
                                }
                            },
                            links: function ($event) {
                                var part =
                                    /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)(.*)?(#[\w\-]+)*\/?$/;

                                var clip = $event.originalEvent.clipboardData;

                                var url = clip ? clip.getData('text') : angular.element($event.currentTarget).val();

                                if (part.test(url) && !$array.$has($scope.formPost.links, { url: url }, 'url')) {
                                    $scope.formPost.processing++;

                                    $scope.formPost.progress.links.push({
                                        name: url,
                                    });
                                    $scope.client
                                        .links($scope.formPost.id)
                                        .upload({
                                            link: url,
                                        })
                                        .then(function (response) {
                                            $scope.formPost.progress.links = $array.$splice(
                                                $scope.formPost.progress.links,
                                                { name: url },
                                                'name'
                                            );
                                            if (response.data.state === 0) {
                                                $scope.formPost.links.push(response.data.data);
                                            } else {
                                                $root.$broadcast('graph-modal-show', {
                                                    title: 'Error',
                                                    content:
                                                        response.data.data.link ||
                                                        'The file is too large or the format is incorrect.',
                                                });
                                            }
                                            $scope.formPost.processing--;
                                        });
                                }
                            },
                        },
                        detach: {
                            photos: function (photo) {
                                if (!photo) {
                                    return;
                                }

                                $scope.formPost.photos = $array.$splice($scope.formPost.photos, photo, 'id');

                                $scope.formPost.new.photos = $array.$splice($scope.formPost.new.photos, photo, 'id');

                                if ($scope.formPost.id === 0) {
                                    $scope.client.photos($scope.formPost.id).delete(photo.id);
                                } else {
                                    $scope.formPost.trash.photos.push(photo);
                                }
                            },
                            videos: function (video) {
                                if (!video) {
                                    return;
                                }

                                $scope.formPost.videos = $array.$splice($scope.formPost.videos, video, 'id');

                                $scope.formPost.new.videos = $array.$splice($scope.formPost.new.videos, video, 'id');
                                if ($scope.formPost.id === 0) {
                                    $scope.client.videos($scope.formPost.id).delete(video.id);
                                } else {
                                    $scope.formPost.trash.videos.push(video);
                                }
                            },
                            documents: function (document) {
                                if (!document) {
                                    return;
                                }

                                $scope.formPost.documents = $array.$splice($scope.formPost.documents, document, 'id');

                                $scope.formPost.new.documents = $array.$splice(
                                    $scope.formPost.new.documents,
                                    document,
                                    'id'
                                );
                                if ($scope.formPost.id === 0) {
                                    $scope.client.documents($scope.formPost.id).delete(document.id);
                                } else {
                                    $scope.formPost.trash.documents.push(document);
                                }
                            },
                            links: function (link) {
                                if (!link) {
                                    return;
                                }

                                $scope.formPost.links = $array.$splice($scope.formPost.links, link, 'id');

                                $scope.formPost.new.links = $array.$splice($scope.formPost.new.links, link, 'id');
                                if ($scope.formPost.id === 0) {
                                    $scope.client.links($scope.formPost.id).delete(link.id);
                                } else {
                                    $scope.formPost.trash.links.push(link);
                                }
                            },
                        },
                        cancel: function () {
                            if ($scope.formPost.processing > 0) return;

                            for (var type in $scope.formPost.new) {
                                var attachment = $scope.formPost.new[type];

                                for (var i = 0; i < attachment.length; i++) {
                                    var attach = attachment[i];

                                    $scope.fn.detach[type](attach);
                                    $scope.formPost.new[type].splice(i, 1);
                                }
                            }

                            for (type in $scope.formPost.trash) {
                                var trash = $scope.formPost.trash[type];

                                for (var j = 0; j < trash.length; j++) {
                                    var item = trash[j];

                                    $scope.formPost[type].push(item);
                                    $scope.formPost.trash[type].splice(j, 1);
                                }
                            }

                            if ($attr.after) {
                                var phase = $scope.$parent.$$phase;
                                if (phase == '$apply' || phase == '$digest') $scope.$parent.$eval($attr.after);
                                else $scope.$parent.$apply($attr.after);
                            }
                        },
                        query: function (data, key) {
                            var values = [];

                            angular.forEach(data[key], function (item) {
                                values.push(angular.isObject(item) ? item.id : item);
                            });

                            return values;
                        },
                    };
                },
            };
        },
    ]);
